// extracted by mini-css-extract-plugin
module.exports = {"richText":"RichText_richText__RW0IH","hyperlink":"RichText_hyperlink__1jEXE","heading":"RichText_heading__Wie8C","rich-text":"RichText_rich-text__hYhcn"};